import { Injectable } from '@angular/core';
import { ShareDataService } from './share-data.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleService {

  timeOutHandle:any=0;
  idleTimeOut:number=600000; // 10 minutes
  isAlertTrigger = new Subject<boolean>();
  isSessionAlertTrigger = new Subject<boolean>();
  isSessionAlertStart = new Subject<boolean>();

  isSessionAlertIntervalTrigger = new Subject<boolean>();
  clearIntercepterAlert = new Subject<boolean>();

  timerInitialised:boolean = false;
  timerTriggered:boolean = false;

  timerInitialisedCount:number = 0;
  timerTriggeredCount:number = 0;

  isUserIdle:boolean = false;

  sendMainIntervalId = new Subject<any>();

  constructor(
    private shareDataService:ShareDataService
  ) { 

    this.shareDataService.isAlertTrigger.subscribe(res => {
      if (res == false) {
        this.resetTimer();
      }
    })
    
  }

  initListener():void {
      window.addEventListener('mousemove',this.resetTimer.bind(this));
      window.addEventListener('mousedown',this.resetTimer.bind(this));
      window.addEventListener('keypress',this.resetTimer.bind(this));
      window.addEventListener('touchmove',this.resetTimer.bind(this));
      window.addEventListener('scroll',this.resetTimer.bind(this));
  }

  resetTimer() {
      clearTimeout(this.timeOutHandle);  
      if (!this.isUserIdle) {
        this.timeOutHandle = setInterval(this.handleIdle.bind(this),this.idleTimeOut);
       
      }
  }

  handleIdle() {
    
    clearTimeout(this.timeOutHandle);
    this.isUserIdle = true;
    
    
    this.timerInitialised = true;
    this.timerTriggered = true;
    this.isAlertTrigger.next(true);
    this.sendMainIntervalId.next(this.timeOutHandle);
  }

  clearTimer() {
    
    clearTimeout(this.timeOutHandle);
    this.isUserIdle = true;
    window.removeEventListener('mousemove',this.resetTimer.bind(this));
    window.removeEventListener('mousedown',this.resetTimer.bind(this));
    window.removeEventListener('keypress',this.resetTimer.bind(this));
    window.removeEventListener('touchmove',this.resetTimer.bind(this));
    window.removeEventListener('scroll',this.resetTimer.bind(this));
  }

}
